import ammonium_nitrate from './General_ammonium_nitrate.jpg'
import AdBlue from './AdBlue.jpg';
import AdBlue_1 from './AdBlue_1.jpg';
import urea from './urea.jpg';
import urea_1 from './urea_1.jpg';
import KAS_2 from './image_KAS32_1.png';
import KarbB_1 from './KarbB_1.jpg' //спзджене з нету


let all_product=[
    {
        id:1,
        name: 'product_AdBlue_name',
        category: 'AdBlue',
        images: [AdBlue_1,AdBlue],
        new_price: '',
        old_price: '',
        description: 'product_AdBlue_description',
    },
    {
        id:2,
        name: 'product_Ammonium_Nitrate_name',
        category: 'MineralFertilizers',
        images: [ammonium_nitrate],
        new_price: '',
        old_price: '',
        description: 'product_Ammonium_Nitrate_description',
    },
    {
        id:3,
        name: 'product_Urea_A_name',
        category: 'MineralFertilizers',
        images: [urea_1, urea],
        new_price: '',
        old_price: '',
        description: 'product_Urea_A_description',
    },
    {
        id:4,
        name: 'product_Urea_B_name',
        category: 'MineralFertilizers',
        images: [KarbB_1],
        new_price: '',
        old_price: '',
        description: 'product_Urea_B_description',
    },
    {
        id:5,
        name: 'product_UAN_32_name',
        category: 'MineralFertilizers',
        images: [KAS_2],
        new_price: '',
        old_price: '',
        description: 'product_UAN_32_description',
    },
]

export default all_product;